import { Component } from '@theme/component';

/** Enhance real rich-text nodes, never split or reconstruct the merchant's HTML. */
class BannannaProductDescription extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#enhance();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#enhance();
  }

  #enhance() {
    if (!this.hasAttribute('collapse-details')) return;
    const content = this.querySelector(':scope > [data-description-content]');
    if (!content) return;

    // Only headings in the editor's main flow are section boundaries. A heading
    // inside a table, list or pasted wrapper must not tear that structure apart.
    const headings = Array.from(content.children).filter((node) => node.tagName === 'H3');
    if (!headings.length) return;
    // Preserve unsupported titles verbatim rather than hide an unnamed section
    // or put a second interactive action inside the native disclosure control.
    if (headings.some((heading) => !heading.textContent?.trim() || heading.querySelector('a, button, input, select, textarea, details, summary'))) return;

    const fragment = document.createDocumentFragment();
    const intro = document.createElement('div');
    intro.className = 'rte bannanna-description__intro';
    let destination = intro;
    for (const node of Array.from(content.childNodes)) {
      if (node instanceof HTMLElement && node.tagName === 'H3') {
        const row = document.createElement('details');
        row.className = 'bannanna-description__row';
        const summary = document.createElement('summary');
        const icon = document.createElement('span');
        icon.className = 'bannanna-description__icon';
        icon.setAttribute('aria-hidden', 'true');
        // Keep heading semantics, inline markup and anchor IDs on the actual node.
        summary.append(node, icon);
        destination = document.createElement('div');
        destination.className = 'rte bannanna-description__body';
        row.append(summary, destination);
        fragment.append(row);
      } else {
        destination.append(node);
      }
    }
    if (intro.hasChildNodes()) {
      if (!intro.textContent?.trim() && !intro.children.length) intro.classList.remove('bannanna-description__intro');
      fragment.prepend(intro);
    }
    content.classList.remove('rte');
    content.replaceChildren(fragment);
  }
}

if (!customElements.get('bannanna-product-description')) {
  customElements.define('bannanna-product-description', BannannaProductDescription);
}
